import Skeleton from '@mui/material/Skeleton';

export default function SkeletonBiblioteca() {
  return (
    <div className='relative w-full'>
      <div className=' flex justify-center items-center flex-col py-4 w-full relative'>

      
        {/* <div className='bg-gray-300 rounded-lg h-36 w-full absolute bottom-2'></div> */}
        <div className='flex flex-col justify-center items-center gap-4 p-6 bg-gray-300 rounded-md'>
          <div className=''>
            <Skeleton variant="rounded" width={150} height={200} animation="pulse" sx={{ bgcolor: 'grey.500' }} />
          </div>
          <div className=''>
            <Skeleton variant="text" width={150} height={20} animation="pulse" sx={{ bgcolor: 'grey.500' }} />
            <Skeleton variant="text" width={150} height={20} animation="pulse" sx={{ bgcolor: 'grey.500' }} />

          </div>
        </div>

      </div>
    </div>
  );
}